// DeleteModal — the app-wide "are you sure?" delete confirmation.
// Rebuilt on top of AppModal so it shares the unified popup chrome, brand theme,
// and loading behaviour. The public prop API is UNCHANGED (show, onDeleteClick,
// onCloseClick, customText, customButtonText, loading) so all existing call-sites
// keep working with no edits.

import PropTypes from "prop-types";
import React from "react";

import AppModal from "./AppModal";

const DeleteModal = ({
  show,
  onDeleteClick,
  onCloseClick,
  customText,
  customButtonText,
  loading,
}) => {
  return (
    <AppModal
      open={show}
      onClose={onCloseClick}
      size="xs"
      hideClose
      dividers={false}
      loading={loading}
      loadingText="Deleting…"
      onSubmit={onDeleteClick}
      submitColor="error"
      submitLabel={customButtonText || "Yes, Delete It!"}
      cancelLabel="Close"
    >
      <div className="text-center py-2">
        <lord-icon
          src="https://cdn.lordicon.com/gsqxdxog.json"
          trigger="loop"
          colors="primary:#405189,secondary:#f06548"
          style={{ width: "90px", height: "90px" }}
        ></lord-icon>
        <div className="mt-3 fs-15">
          <h4 className="mb-1">Are you sure?</h4>
          <p className="text-muted mb-0">
            {customText || "Are you sure you want to remove this record ?"}
          </p>
        </div>
      </div>
    </AppModal>
  );
};

DeleteModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
  customText: PropTypes.node,
  customButtonText: PropTypes.node,
  loading: PropTypes.bool,
};

export default DeleteModal;
